"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenVesting = void 0;
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var borsh_1 = require("@solvei/borsh");
var bn_js_1 = __importDefault(require("bn.js"));
var accounts_1 = require("./accounts");
var query_1 = require("./query");
var schema_1 = require("./schema");
var TokenVesting = /** @class */ (function () {
    function TokenVesting(connection, programId, mint, sender, creator, vestingsCreator, vestingName) {
        this.connection = connection;
        this.programId = programId;
        this.mint = mint;
        this.sender = sender;
        this.creator = creator;
        this.vestingsCreator = vestingsCreator;
        this.vestingName = vestingName;
        var vestingContext = this.getContext();
        this.configAccessor = new accounts_1.ConfigAccessor(vestingContext);
        this.associatedTokenAccessor = new accounts_1.AssociatedTokenAccessor(vestingContext);
        this.tokenPoolAccessor = new accounts_1.TokenPoolAccessor(vestingContext);
        this.vestingTypeAccessor = new accounts_1.VestingTypeAccessor(vestingContext);
        this.vestingAccessor = new accounts_1.VestingAccessor(vestingContext);
    }
    TokenVesting.prototype.getContext = function () {
        return {
            connection: this.connection,
            programId: this.programId,
            mint: this.mint,
            sender: this.sender,
            creator: this.creator,
            vestingsCreator: this.vestingsCreator,
            vestingName: this.vestingName,
        };
    };
    TokenVesting.prototype.createConfig = function (createConfigInstruction) {
        return __awaiter(this, void 0, void 0, function () {
            var configAccount, instance, instructionData, createConfig, transaction, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.validateOnlyCreator();
                        return [4 /*yield*/, this.configAccessor.nonExisting()];
                    case 1:
                        configAccount = _c.sent();
                        instance = new schema_1.Instruction(createConfigInstruction);
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        createConfig = new web3_js_1.TransactionInstruction({
                            keys: [
                                { pubkey: this.sender, isSigner: true, isWritable: true },
                                configAccount.getWritableAccountMeta(),
                            ],
                            programId: this.programId,
                            data: Buffer.from(instructionData),
                        });
                        transaction = new web3_js_1.Transaction();
                        _b = (_a = transaction).add;
                        return [4 /*yield*/, configAccount.getCreateInstruction()];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        transaction.add(createConfig);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenVesting.prototype.createVestingType = function (amountLamorts, createVestingTypeInstruction) {
        return __awaiter(this, void 0, void 0, function () {
            var creatorTokens, tokenPool, vestingType, instance, instructionData, createVestingType, transaction, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        this.validateOnlyCreator();
                        return [4 /*yield*/, this.associatedTokenAccessor.existing(this.sender)];
                    case 1:
                        creatorTokens = _e.sent();
                        return [4 /*yield*/, this.tokenPoolAccessor.nonExisting()];
                    case 2:
                        tokenPool = _e.sent();
                        return [4 /*yield*/, this.vestingTypeAccessor.nonExisting()];
                    case 3:
                        vestingType = _e.sent();
                        instance = new schema_1.Instruction(createVestingTypeInstruction);
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        createVestingType = new web3_js_1.TransactionInstruction({
                            keys: [
                                { pubkey: this.creator, isSigner: true, isWritable: true },
                                vestingType.getWritableAccountMeta(),
                                tokenPool.getWritableAccountMeta(),
                                {
                                    pubkey: spl_token_1.TOKEN_PROGRAM_ID,
                                    isSigner: false,
                                    isWritable: false,
                                },
                            ],
                            programId: this.programId,
                            data: Buffer.from(instructionData),
                        });
                        transaction = new web3_js_1.Transaction();
                        _b = (_a = transaction).add;
                        return [4 /*yield*/, tokenPool.getCreateInstruction()];
                    case 4:
                        _b.apply(_a, [_e.sent()]);
                        transaction.add(tokenPool.getInitInstruction());
                        transaction.add(tokenPool.getTransferInstruction(creatorTokens.pubkey, amountLamorts));
                        _d = (_c = transaction).add;
                        return [4 /*yield*/, vestingType.getCreateInstruction()];
                    case 5:
                        _d.apply(_c, [_e.sent()]);
                        transaction.add(createVestingType);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenVesting.prototype.withdrawExcessiveFromPool = function (withdrawExcessiveFromPoolInstruction) {
        return __awaiter(this, void 0, void 0, function () {
            var creatorTokens, tokenPool, vestingType, instance, instructionData, withdrawInstruction, _a, _b, transaction;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.associatedTokenAccessor.existing(this.sender)];
                    case 1:
                        creatorTokens = _d.sent();
                        return [4 /*yield*/, this.tokenPoolAccessor.existing()];
                    case 2:
                        tokenPool = _d.sent();
                        return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 3:
                        vestingType = _d.sent();
                        this.validateOnlyAdministrator(vestingType.data);
                        instance = new schema_1.Instruction(withdrawExcessiveFromPoolInstruction);
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        _a = web3_js_1.TransactionInstruction.bind;
                        _c = {};
                        _b = [{ pubkey: this.sender, isSigner: true, isWritable: true },
                            creatorTokens.getWritableAccountMeta()];
                        return [4 /*yield*/, vestingType.getTokenPoolPdaAccountMeta()];
                    case 4:
                        withdrawInstruction = new (_a.apply(web3_js_1.TransactionInstruction, [void 0, (_c.keys = _b.concat([
                                _d.sent(),
                                tokenPool.getWritableAccountMeta(),
                                vestingType.getWritableAccountMeta(),
                                { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false }
                            ]),
                                _c.programId = this.programId,
                                _c.data = Buffer.from(instructionData),
                                _c)]))();
                        transaction = new web3_js_1.Transaction();
                        transaction.add(withdrawInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenVesting.prototype.changeVestingTypeSchedule = function (changeVestingTypeScheduleInstruction) {
        return __awaiter(this, void 0, void 0, function () {
            var vestingType, instance, instructionData, changeVestingTypeSchedule, transaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingType = _a.sent();
                        this.validateOnlyAdministrator(vestingType.data);
                        instance = new schema_1.Instruction(changeVestingTypeScheduleInstruction);
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        changeVestingTypeSchedule = new web3_js_1.TransactionInstruction({
                            keys: [
                                { pubkey: this.sender, isSigner: true, isWritable: true },
                                vestingType.getWritableAccountMeta(),
                            ],
                            programId: this.programId,
                            data: Buffer.from(instructionData),
                        });
                        transaction = new web3_js_1.Transaction();
                        transaction.add(changeVestingTypeSchedule);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenVesting.prototype.createVestingAccount = function (receiver, createVestingInstruction) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenPool, vestingType, vesting, receiverToken, transaction, instance, instructionData, createVesting, _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.tokenPoolAccessor.existing()];
                    case 1:
                        tokenPool = _e.sent();
                        return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 2:
                        vestingType = _e.sent();
                        return [4 /*yield*/, this.vestingAccessor.nonExisting(receiver)];
                    case 3:
                        vesting = _e.sent();
                        return [4 /*yield*/, this.associatedTokenAccessor.get(receiver)];
                    case 4:
                        receiverToken = _e.sent();
                        this.validateOnlyVestingCreator();
                        this.validateOnlyAdministrator(vestingType.data);
                        transaction = new web3_js_1.Transaction();
                        instance = new schema_1.Instruction(createVestingInstruction);
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        createVesting = new web3_js_1.TransactionInstruction({
                            keys: [
                                { pubkey: this.sender, isSigner: true, isWritable: true },
                                vestingType.getWritableAccountMeta(),
                                vesting.getWritableAccountMeta(),
                                receiverToken.getWritableAccountMeta(),
                                tokenPool.getWritableAccountMeta(),
                            ],
                            programId: this.programId,
                            data: Buffer.from(instructionData),
                        });
                        if (!!receiverToken.data) return [3 /*break*/, 6];
                        _b = (_a = transaction).add;
                        return [4 /*yield*/, receiverToken.getCreateInstruction()];
                    case 5:
                        _b.apply(_a, [_e.sent()]);
                        _e.label = 6;
                    case 6:
                        _d = (_c = transaction).add;
                        return [4 /*yield*/, vesting.getCreateInstruction()];
                    case 7:
                        _d.apply(_c, [_e.sent()]);
                        transaction.add(createVesting);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenVesting.prototype.withdrawFromVesting = function (receiverPubkey, withdrawFromVestingInstruction) {
        return __awaiter(this, void 0, void 0, function () {
            var tokenPool, vestingType, vesting, receiverToken, instance, instructionData, withdrawInstruction, _a, _b, transaction;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.tokenPoolAccessor.existing()];
                    case 1:
                        tokenPool = _d.sent();
                        return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 2:
                        vestingType = _d.sent();
                        return [4 /*yield*/, this.vestingAccessor.existing(receiverPubkey)];
                    case 3:
                        vesting = _d.sent();
                        return [4 /*yield*/, this.associatedTokenAccessor.existing(receiverPubkey)];
                    case 4:
                        receiverToken = _d.sent();
                        instance = new schema_1.Instruction(withdrawFromVestingInstruction);
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        _a = web3_js_1.TransactionInstruction.bind;
                        _c = {};
                        _b = [vestingType.getWritableAccountMeta(),
                            vesting.getWritableAccountMeta(),
                            receiverToken.getWritableAccountMeta(),
                            tokenPool.getWritableAccountMeta()];
                        return [4 /*yield*/, vestingType.getTokenPoolPdaAccountMeta()];
                    case 5:
                        withdrawInstruction = new (_a.apply(web3_js_1.TransactionInstruction, [void 0, (_c.keys = _b.concat([
                                _d.sent(),
                                { pubkey: spl_token_1.TOKEN_PROGRAM_ID, isSigner: false, isWritable: false }
                            ]),
                                _c.programId = this.programId,
                                _c.data = Buffer.from(instructionData),
                                _c)]))();
                        transaction = new web3_js_1.Transaction();
                        transaction.add(withdrawInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenVesting.prototype.changeAdministrator = function (changeAdministratorInstruction) {
        return __awaiter(this, void 0, void 0, function () {
            var vestingType, instance, instructionData, withdrawInstruction, transaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingType = _a.sent();
                        this.validateOnlyAdministrator(vestingType.data);
                        instance = new schema_1.Instruction(changeAdministratorInstruction);
                        instructionData = (0, borsh_1.serialize)(schema_1.schemas, instance);
                        withdrawInstruction = new web3_js_1.TransactionInstruction({
                            keys: [
                                { pubkey: this.sender, isSigner: true, isWritable: true },
                                vestingType.getWritableAccountMeta(),
                            ],
                            programId: this.programId,
                            data: Buffer.from(instructionData),
                        });
                        transaction = new web3_js_1.Transaction();
                        transaction.add(withdrawInstruction);
                        return [2 /*return*/, transaction];
                }
            });
        });
    };
    TokenVesting.prototype.getVestingStatistic = function (receiver) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var vestingTypeAccount, vestingAccount, vestingType, vesting, now, allTokens, availableToWithdrawTokens, unlockedTokens;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 1:
                        vestingTypeAccount = _b.sent();
                        return [4 /*yield*/, this.vestingAccessor.existing(receiver)];
                    case 2:
                        vestingAccount = _b.sent();
                        vestingType = vestingTypeAccount.data;
                        vesting = vestingAccount.data;
                        if (!vestingType.token_pool || !vestingType.vesting_schedule)
                            throw Error("Deserialization error");
                        if (!vesting.total_tokens ||
                            !vesting.withdrawn_tokens ||
                            !vesting.token_account ||
                            !vesting.vesting_type_account)
                            throw Error("Deserialization error");
                        now = Math.floor(Date.now() / 1000);
                        allTokens = vesting.total_tokens;
                        availableToWithdrawTokens = vesting.calculate_available_to_withdraw_amount(vestingType.vesting_schedule, now);
                        unlockedTokens = vesting.withdrawn_tokens.add(availableToWithdrawTokens);
                        return [2 /*return*/, new query_1.VestingStatistic((_a = vesting.is_active) !== null && _a !== void 0 ? _a : false, allTokens, unlockedTokens, availableToWithdrawTokens, vesting.withdrawn_tokens, vesting.token_account, vesting.vesting_type_account)];
                }
            });
        });
    };
    TokenVesting.prototype.getVestingTypeStatistic = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tokenPoolAccount, vestingTypeAccount, tokenPool, vestingType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenPoolAccessor.existing()];
                    case 1:
                        tokenPoolAccount = _a.sent();
                        return [4 /*yield*/, this.vestingTypeAccessor.existing()];
                    case 2:
                        vestingTypeAccount = _a.sent();
                        tokenPool = tokenPoolAccount.data;
                        vestingType = vestingTypeAccount.data;
                        if (!vestingType.token_pool ||
                            !vestingType.vesting_schedule ||
                            !vestingType.locked_tokens_amount ||
                            !vestingType.administrator)
                            throw Error("Deserialization error");
                        return [2 /*return*/, new query_1.VestingTypeStatistic(vestingType.vesting_schedule, vestingType.locked_tokens_amount, vestingType.administrator, vestingType.token_pool, new bn_js_1.default(tokenPool.amount))];
                }
            });
        });
    };
    TokenVesting.prototype.getAssociatedTokenData = function (wallet) {
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.associatedTokenAccessor.existing(wallet)];
                    case 1:
                        account = _a.sent();
                        return [2 /*return*/, account.data];
                }
            });
        });
    };
    TokenVesting.prototype.getConfigData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configAccessor.existing()];
                    case 1:
                        account = _a.sent();
                        return [2 /*return*/, account.data];
                }
            });
        });
    };
    TokenVesting.prototype.validateOnlyCreator = function () {
        if (!this.creator.equals(this.sender)) {
            throw new Error("Only contract deployer can call this method!");
        }
    };
    TokenVesting.prototype.validateOnlyVestingCreator = function () {
        if (!this.vestingsCreator.equals(this.sender)) {
            throw new Error("Only vesting creator can call this method!");
        }
    };
    TokenVesting.prototype.validateOnlyAdministrator = function (vestingType) {
        var _a;
        if (!((_a = vestingType.administrator) === null || _a === void 0 ? void 0 : _a.equals(this.sender))) {
            throw Error("Cannot call if not an administrator");
        }
    };
    return TokenVesting;
}());
exports.TokenVesting = TokenVesting;
//# sourceMappingURL=token-vesing.js.map